import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { getFieldType } from '@mds/ui';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-epd-edit-section',
  standalone: true,
  templateUrl: './epd-edit-section.component.html',
  styleUrls: ['./epd-edit-section.component.scss'],
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    MatCardModule,
    MatIconModule
],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpdEditSectionComponent implements OnInit {
  @Input() data;
  @Output() modelChanged = new EventEmitter<any>();
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);

  setupForm = new FormGroup({});
  formSchema;
  section;

  get showValidBanner() {
    return this.setupForm.disabled || this.setupForm.valid;
  }

  get bannerIcon() {
    return this.showValidBanner ? 'check_circle_outline' : 'error_outline';
  }

  get bannerClass() {
    return this.showValidBanner ? 'banner form-valid' : 'banner form-invalid';
  }

  get bannerText() {
    return this.showValidBanner
      ? 'We’ve got all the info we need here. You can still edit the values if they need adjustments.'
      : 'There are mandatory fields that still need information in this section.';
  }

  ngOnInit(): void {
    this.formSchema = this.data;
    this.section = this.createFieldTypes(this.data);
    this.setupForm.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((formValue) => {
      this.modelChanged.emit({
        key: this.data.key,
        value: this.setupForm.value,
        valid: this.setupForm.valid,
        reset: this.setupForm.reset.bind(this)
      });
    });

    setTimeout(() => {
      this.cdr.detectChanges();
    });
  }

  private createFieldTypes(section) {
    this.sortFormSchema(section.formSchema);
    return section.formSchema.map((form) => ({
      key: form.key,
      defaultValue: form.value || form.defaultValue,
      type: getFieldType(form.key, form.fieldtype, form.formtype),
      templateOptions: {
        label: form.title || form.label,
        info: form.description,
        disabled: !form.is_editable,
        vertical: true,
        type: form.fieldtype,
        required: form.mandatory,
        options: ['radio', 'select'].includes(form.formtype) ? form.enums : []
      }
    }));
  }

  private sortFormSchema(formSchema) {
    formSchema.sort((a, b) => a.sortlevel - b.sortlevel);
  }
}
